import Cookies from 'js-cookie'

import { cartDetailsVar, totalQuantityVar } from '../cache/cart'
import { ROLE } from '../staticRoleManagement/types'
import { Credentails } from '../types/auth'
import { Currency } from '../types/currency'

export const getCredentialsFromStorage = () => {
  const CookiesStorageUser: Credentails | undefined = Cookies.get('credentials')
    ? JSON.parse(Cookies.get('credentials') || '')
    : undefined
  return CookiesStorageUser || undefined
}

export const saveCredentialsIntoStorage = (
  user: Credentails,
  permanentSave: boolean
) => {
  Cookies.set('credentials', JSON.stringify(user), {
    expires: permanentSave ? 365 : undefined
  })
}

export const getTokenFromStorage = (): string | undefined => {
  const storageUser = getCredentialsFromStorage()

  return storageUser?.accessToken
}

export const getNameFromStorage = (): string | undefined => {
  const storageUser = getCredentialsFromStorage()

  return storageUser?.name
}

export const getEmailFromStorage = (): string | undefined => {
  const storageUser = getCredentialsFromStorage()

  return storageUser?.email
}

export const getRoleFromStorage = (): ROLE => {
  const storageUser = getCredentialsFromStorage()

  return ROLE[storageUser!.role as ROLE]
}

export const getEntityCode = (): string | undefined => {
  const storageUser = getCredentialsFromStorage()

  return storageUser?.entityCode
}

export const getEntityId = (): string | undefined => {
  const storageUser = getCredentialsFromStorage()

  return storageUser?.entityId
}

export const getEntityName = (): string | undefined => {
  const storageUser = getCredentialsFromStorage()

  return storageUser?.entityName
}

export const getLanguagesAvailable = (): string[] => {
  const storageUser = getCredentialsFromStorage()

  const languagesAvailable = storageUser?.regionalSettings.LanguagesAvailable

  return languagesAvailable || []
}

export const isFaAvailableInLanguages = (): boolean => {
  const storageUser = getCredentialsFromStorage()

  const languagesAvailable = storageUser?.regionalSettings.LanguagesAvailable

  const response = languagesAvailable?.includes('FA')

  return response || false
}

export const getCurrenciesAvailable = (): Currency[] => {
  const storageUser = getCredentialsFromStorage()

  const currenciesAvailable = storageUser?.regionalSettings.CurrenciesAvailable

  return currenciesAvailable || []
}

export const getDefaultCurrency = (): Currency => {
  const storageUser = getCredentialsFromStorage()

  const defaultCurrency = storageUser?.regionalSettings.DefaultCurrency

  return defaultCurrency
}

export const getTimeZone = (): string => {
  const storageUser = getCredentialsFromStorage()

  const timezone = storageUser?.regionalSettings.Timezone

  return timezone || ''
}

export const cleanCartData = () => {
  totalQuantityVar(0)
  localStorage.removeItem('cartDetails')
  localStorage.removeItem('totalQuantity')
  localStorage.removeItem('cartID')
  cartDetailsVar({
    propertyCode: '',
    currrncy: '',
    arrival: '',
    departure: '',
    guestsAges: [],
    providerCodes: [],
    channelId: ''
  })
}
